import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import ArrowIcon from "../assets/images/arrow.svg";

const HeroSlider = ({ slides }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <div className="hero-slider-wrapper">
      <div className="slide-count">
        <span className="slide-count__index">0{activeIndex + 1}</span>
        <span>/</span>
        <span>0{slides.length}</span>
      </div>

      <Swiper
        key={slides.map((s) => s.id).join("-")}
        navigation={{
          nextEl: ".swiper-button-next-arrow",
          prevEl: ".swiper-button-prev-arrow",
        }}
        modules={[Autoplay, Navigation]}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        loop={true}
        speed={800}
        onSlideChangeTransitionEnd={(swiper) => {
          setActiveIndex(swiper.realIndex);
        }}
        className="hero-slider"
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <p className="slide-text">{slide.text}</p>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="slider-nav-wrapper">
        <div className="swiper-button-prev-arrow custom-nav">
          <img src={ArrowIcon} alt="Назад" />
        </div>
        <div className="swiper-button-next-arrow custom-nav">
          <img src={ArrowIcon} alt="Вперёд" />
        </div>
      </div>
    </div>
  );
};

export default HeroSlider;
